
import React, { useState } from 'react';

const Home: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Fechar menu mobile após clicar
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      {/* Hero Section with Background Image */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 30, 60, 0.8), rgba(0, 30, 60, 0.8)), url('https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/8c6ea2cd5577d3bd3d222865e08420f1.png')`
        }}
      >
        {/* Fixed Navigation */}
        <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-sm">
          <div className="w-full mx-auto px-4 sm:px-6 py-3 sm:py-4">
            <div className="flex items-center justify-between">
              <div className="text-white">
                <h1 className="text-lg sm:text-xl font-bold">Residencial Maitê</h1>
                <p className="text-xs opacity-90 hidden sm:block">Casa Grande Empreendimentos Imobiliários</p>
              </div>
              
              {/* Desktop Menu */}
              <div className="hidden md:flex space-x-6 lg:space-x-8">
                <button 
                  onClick={() => scrollToSection('oportunidade')}
                  className="text-white hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap text-sm lg:text-base"
                >
                  Oportunidade
                </button>
                <button 
                  onClick={() => scrollToSection('rentabilidade')}
                  className="text-white hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap text-sm lg:text-base"
                >
                  Rentabilidade
                </button>
                <button 
                  onClick={() => scrollToSection('projetos')}
                  className="text-white hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap text-sm lg:text-base"
                >
                  Projeto
                </button>
              </div>
              
              {/* Mobile Menu Button */}
              <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="md:hidden text-white text-2xl cursor-pointer p-2"
              >
                <i className={isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}></i>
              </button>
            </div>
            
            {/* Mobile Menu */}
            {isMobileMenuOpen && (
              <div className="md:hidden mt-4 pb-4 border-t border-gray-600">
                <div className="flex flex-col space-y-4 pt-4">
                  <button 
                    onClick={() => scrollToSection('oportunidade')}
                    className="text-white hover:text-yellow-400 transition-colors cursor-pointer text-left py-2"
                  >
                    Oportunidade
                  </button>
                  <button 
                    onClick={() => scrollToSection('rentabilidade')}
                    className="text-white hover:text-yellow-400 transition-colors cursor-pointer text-left py-2"
                  >
                    Rentabilidade
                  </button>
                  <button 
                    onClick={() => scrollToSection('projetos')}
                    className="text-white hover:text-yellow-400 transition-colors cursor-pointer text-left py-2"
                  >
                    Projeto
                  </button>
                </div>
              </div>
            )}
          </div>
        </nav>

        {/* Hero Content */}
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 text-center text-white pt-20">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
              Terreno para Incorporação
              <span className="block text-yellow-400 mt-2">São José dos Campos, SP</span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 opacity-90 leading-relaxed px-2">
              Invista em terrenos estratégicos para incorporação imobiliária
              <span className="block font-semibold text-yellow-300 mt-2">
                A partir de R$ 250.000 - Valorização de 30% ao ano e 41,33% no periodo de 20 meses.
              </span>
            </p>
            <div className="flex justify-center px-4">
              <a 
                href="https://wa.me/5512999999999?text=Olá! Tenho interesse em fazer parte do empreendimento de terreno para incorporação em São José dos Campos, SP. Gostaria de mais informações sobre o grupo de investidores."
                target="_blank"
                rel="noopener noreferrer"
                className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 sm:px-6 lg:px-10 py-3 sm:py-4 lg:py-5 rounded-lg font-bold text-sm sm:text-base lg:text-xl transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 sm:gap-3 shadow-lg"
              >
                <i className="ri-whatsapp-line text-lg sm:text-xl lg:text-2xl"></i>
                <span className="hidden sm:inline">Fazer Parte do Empreendimento</span>
                <span className="sm:hidden">Participar</span>
              </a>
            </div>
            <div className="mt-6 sm:mt-8 bg-black/30 backdrop-blur-sm rounded-lg p-4 sm:p-6 mx-2">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs sm:text-sm">
                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-yellow-400"></i>
                  <span>São José dos Campos, SP</span>
                </div>
                <div className="flex items-center gap-2 text-center">
                  <i className="ri-line-chart-line text-yellow-400"></i>
                  <span>41,33% no periodo de 20 a 24 Meses</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-money-dollar-circle-line text-yellow-400"></i>
                  <span>A partir de R$ 250k</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* Why Invest Section */}
      <section id="oportunidade" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
              Por que Investir em Terreno para Incorporação?
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Uma oportunidade única de participar desde a fase inicial do projeto imobiliário, 
              com potencial de retorno excepcional e risco controlado.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
            <div className="bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow mx-2 md:mx-0">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-line-chart-line text-xl sm:text-2xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">Alta Rentabilidade</h3>
              <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
                Retorno de 41,33% no periodo de obra, muito acima dos investimentos tradicionais do mercado.
              </p>
              <div className="text-2xl sm:text-3xl font-bold text-yellow-600">41,33%</div>
              <div className="text-xs sm:text-sm text-gray-500">no periodo de obra</div>
            </div>

            <div className="bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow mx-2 md:mx-0">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-building-line text-xl sm:text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">Localização Estratégica</h3>
              <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
                São José dos Campos, SP - região em constante crescimento e valorização imobiliária.
              </p>
              <div className="text-base sm:text-lg font-semibold text-blue-600">Vale do Paraíba</div>
            </div>

            <div className="bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow mx-2 md:mx-0 md:col-span-2 lg:col-span-1">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-shield-check-line text-xl sm:text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">Segurança Jurídica</h3>
              <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
                Contratos sólidos e garantias que protegem seu investimento em todas as fases.
              </p>
              <div className="text-base sm:text-lg font-semibold text-purple-600">100% Protegido</div>
            </div>
          </div>

          {/* Investment Simulation */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-6 sm:p-8 md:p-12 text-white mb-8 sm:mb-12 mx-2 sm:mx-0">
            <div className="text-center mb-6 sm:mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">Simulação: Investimento de R$ 1 Milhão</h3>
              <p className="text-base sm:text-lg lg:text-xl text-gray-300 px-2">
                Investimento em terreno com permuta por 5 unidades prontas no empreendimento
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8">
              <div className="bg-blue-600/20 rounded-lg p-4 sm:p-6">
                <h4 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-blue-400">Investimento Inicial</h4>
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex justify-between text-sm sm:text-base">
                    <span className="text-gray-300">Valor investido:</span>
                    <span className="text-white font-bold">R$ 1.000.000</span>
                  </div>
                  <div className="flex justify-between text-sm sm:text-base">
                    <span className="text-gray-300">Modalidade:</span>
                    <span className="text-blue-400 font-semibold">Permuta</span>
                  </div>
                  <div className="flex justify-between text-sm sm:text-base">
                    <span className="text-gray-300">Participação:</span>
                    <span className="text-blue-400 font-semibold">Sócio na matrícula</span>
                  </div>
                </div>
              </div>

              <div className="bg-green-600/20 rounded-lg p-4 sm:p-6">
                <h4 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-green-400">Retorno da Permuta</h4>
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex justify-between text-sm sm:text-base">
                    <span className="text-gray-300">Unidades recebidas:</span>
                    <span className="text-green-400 font-bold">5 apartamentos</span>
                  </div>
                  <div className="flex justify-between text-sm sm:text-base">
                    <span className="text-gray-300">Valor atual por unidade:</span>
                    <span className="text-white font-bold">R$ 340.000</span>
                  </div>
                  <div className="flex justify-between text-sm sm:text-base">
                    <span className="text-gray-300">Valor total das unidades:</span>
                    <span className="text-green-400 font-bold">R$ 1.700.000</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-green-600/30 to-blue-600/30 rounded-lg p-6 sm:p-8 text-center">
              <h4 className="text-2xl sm:text-3xl font-bold mb-4">Resultado da Operação</h4>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
                <div className="mb-4 sm:mb-0">
                  <div className="text-xs sm:text-sm text-gray-300 mb-2">Investimento Inicial</div>
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">R$ 1.000.000</div>
                </div>
                <div className="mb-4 sm:mb-0">
                  <div className="text-xs sm:text-sm text-gray-300 mb-2">Valor das 5 Unidades em 20 meses</div>
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-green-400">R$ 1.700.000</div>
                </div>
                <div>
                  <div className="text-xs sm:text-sm text-gray-300 mb-2">Lucro Líquido</div>
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-yellow-400">R$ 700.000</div>
                  <div className="text-xs sm:text-sm text-yellow-300 mt-1">70% de rentabilidade</div>
                </div>
              </div>
            </div>

            <div className="mt-6 sm:mt-8 bg-gray-800/50 rounded-lg p-4 sm:p-6">
              <h5 className="text-lg sm:text-xl font-bold mb-4 text-center">Vantagens da Permuta</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex items-center gap-3 text-sm sm:text-base">
                    <i className="ri-check-line text-yellow-400 text-lg sm:text-xl flex-shrink-0"></i>
                    <span className="text-gray-300">Participação na matrícula do terreno</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm sm:text-base">
                    <i className="ri-check-line text-yellow-400 text-lg sm:text-xl flex-shrink-0"></i>
                    <span className="text-gray-300">Recebimento de 5 unidades prontas</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm sm:text-base">
                    <i className="ri-check-line text-yellow-400 text-lg sm:text-xl flex-shrink-0"></i>
                    <span className="text-gray-300">Valorização garantida do imóvel</span>
                  </div>
                </div>
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex items-center gap-3 text-sm sm:text-base">
                    <i className="ri-check-line text-yellow-400 text-lg sm:text-xl flex-shrink-0"></i>
                    <span className="text-gray-300">Renda mensal com aluguel</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm sm:text-base">
                    <i className="ri-check-line text-yellow-400 text-lg sm:text-xl flex-shrink-0"></i>
                    <span className="text-gray-300">Segurança jurídica total</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm sm:text-base">
                    <i className="ri-check-line text-yellow-400 text-lg sm:text-xl flex-shrink-0"></i>
                    <span className="text-gray-300">Patrimônio físico consolidado</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Valorization Projection */}
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-6 sm:p-8 md:p-12 text-white mt-8 sm:mt-12 mx-4 sm:mx-6 max-w-7xl lg:mx-auto">
        <div className="text-center mb-6 sm:mb-8">
          <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">Projeção de Valorização</h3>
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 px-2">
            Acompanhe como seu investimento pode evoluir ao longo do tempo
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
          <div className="text-center">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-line text-xl sm:text-2xl text-white"></i>
            </div>
            <h4 className="font-bold mb-2 text-sm sm:text-base">Investimento Atual</h4>
            <p className="text-xs sm:text-sm text-gray-300">Investimento inicial</p>
            <div className="text-xl sm:text-2xl font-bold text-yellow-400 mt-2">R$ 250k</div>
          </div>

          <div className="text-center">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-2-line text-xl sm:text-2xl text-white"></i>
            </div>
            <h4 className="font-bold mb-2 text-sm sm:text-base">Após 20 Meses</h4>
            <p className="text-xs sm:text-sm text-gray-300">41,3% no periodo de 20 meses</p>
            <div className="text-xl sm:text-2xl font-bold text-blue-400 mt-2">R$ 340k</div>
          </div>
        </div>
      </div>

      {/* Profitability Comparison */}
      <section id="rentabilidade" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
              Comparativo de Rentabilidade
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Veja como nossos investimentos superam as aplicações tradicionais do mercado
            </p>
          </div>

          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-6 sm:p-8 md:p-12 text-white mb-8 sm:mb-12 mx-2 sm:mx-0">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-center">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Investimentos Tradicionais vs Casagrande</h3>
                <div className="space-y-3 sm:space-y-4">
                  <div className="flex justify-between items-center py-2 sm:py-3 border-b border-gray-700 text-sm sm:text-base">
                    <span className="text-gray-300">Poupança</span>
                    <span className="text-red-400 font-semibold">6,17% a.a.</span>
                  </div>
                  <div className="flex justify-between items-center py-2 sm:py-3 border-b border-gray-700 text-sm sm:text-base">
                    <span className="text-gray-300">CDI</span>
                    <span className="text-gray-400 font-semibold">13,75% a.a.</span>
                  </div>
                  <div className="flex justify-between items-center py-2 sm:py-3 border-b border-gray-700 text-sm sm:text-base">
                    <span className="text-gray-300">Tesouro Direto</span>
                    <span className="text-gray-400 font-semibold">12,50% a.a.</span>
                  </div>
                  <div className="flex justify-between items-center py-2 sm:py-3 border-b border-gray-700 text-sm sm:text-base">
                    <span className="text-gray-300">Fundos Imobiliários</span>
                    <span className="text-gray-400 font-semibold">8-15% a.a.</span>
                  </div>
                  <div className="flex justify-between items-center py-2 sm:py-3 text-sm sm:text-base">
                    <span className="text-white font-semibold">Casagrande Empreendimentos</span>
                    <span className="text-yellow-400 font-bold text-base sm:text-xl">41,33% no periodo de 20 meses</span>
                  </div>
                </div>
              </div>
              <div className="text-center mt-6 lg:mt-0">
                <div className="text-4xl sm:text-5xl lg:text-6xl font-bold text-yellow-400 mb-4">2.2x</div>
                <p className="text-base sm:text-lg lg:text-xl text-gray-300 mb-4 sm:mb-6 px-2">
                  Mais rentável que investimentos tradicionais
                </p>
                <div className="bg-yellow-600/20 rounded-lg p-4 sm:p-6">
                  <h4 className="text-xl sm:text-2xl font-bold mb-2">Potencial de Dobrar</h4>
                  <p className="text-gray-300 text-sm sm:text-base">
                    Seu capital pode crescer muito + com a valorização constante.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center">
            <div className="bg-gray-50 p-6 sm:p-8 rounded-xl text-center max-w-sm w-full mx-4 sm:mx-0">
              <div className="text-3xl sm:text-4xl font-bold text-yellow-600 mb-2">R$ 250k</div>
              <div className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">Investimento Initial</div>
              <div className="text-xl sm:text-2xl font-bold text-gray-900">Após 20 meses</div>
              <div className="text-2xl sm:text-3xl font-bold text-yellow-600 mt-2">R$ 390k</div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projetos" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
              Nosso Projeto em São José dos Campos
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Terreno localizado na Vila Iracema, (região do bairro Putim).
            </p>
          </div>

          <div className="max-w-4xl mx-auto mb-12 sm:mb-16">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden mx-2 sm:mx-0">
              <img 
                src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/809d98178ff59a1202eb29f765ef0fec.jfif"
                alt="Projeto Residencial Premium"
                className="w-full h-60 sm:h-80 object-cover object-center"
              />
              <div className="p-6 sm:p-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Residencial Maitê</h3>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
                  <div className="space-y-2 sm:space-y-3">
                    <div className="flex items-start gap-3 text-sm sm:text-base">
                      <i className="ri-map-pin-line text-yellow-600 mt-1 flex-shrink-0"></i>
                      <span className="text-gray-600">Rua Itambacuri, ao lado do 233, Vila Iracema.</span>
                    </div>
                    <div className="flex items-center gap-3 text-sm sm:text-base">
                      <i className="ri-home-line text-yellow-600 flex-shrink-0"></i>
                      <span className="text-gray-600">28 Unidades</span>
                    </div>
                    <div className="flex items-start gap-3 text-sm sm:text-base">
                      <i className="ri-calendar-line text-yellow-600 mt-1 flex-shrink-0"></i>
                      <span className="text-gray-600">Prazo obra: 20 e 24 meses.</span>
                    </div>
                  </div>
                  <div className="space-y-2 sm:space-y-3">
                    <div className="text-xs sm:text-sm text-gray-500">Rentabilidade Projetada</div>
                    <div className="text-2xl sm:text-3xl font-bold text-yellow-600">41,33% periodo de 20 meses.</div>
                    <div className="text-xs sm:text-sm text-gray-500">Investimento Mínimo</div>
                    <div className="text-2xl sm:text-3xl font-bold text-gray-900">R$ 250k</div>
                  </div>
                </div>

                <div className="bg-yellow-100 rounded-lg p-3 sm:p-4 mb-4 sm:mb-6">
                  <div className="text-sm font-semibold text-yellow-800">Status: Captando Investidores</div>
                  <div className="text-xs text-yellow-600 mt-1">60% dos recursos já captados</div>
                </div>

                <div className="text-center">
                  <a 
                    href="https://wa.me/5512999999999?text=Olá! Tenho interesse em fazer parte do empreendimento Residencial Jardim das Colinas. Gostaria de mais informações sobre o grupo de investidores."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 sm:px-6 lg:px-8 py-3 sm:py-4 rounded-lg font-bold text-sm sm:text-base lg:text-lg transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2 sm:gap-3"
                  >
                    <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
                    <span className="hidden sm:inline">Fazer Parte do Empreendimento</span>
                    <span className="sm:hidden">Participar</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Exclusive Investors Group */}
          <div className="bg-gradient-to-r from-yellow-500 to-blue-600 rounded-2xl p-6 sm:p-8 md:p-12 text-white text-center mx-2 sm:mx-0">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4">Grupo Exclusivo de Investidores</h3>
            <p className="text-base sm:text-lg lg:text-xl mb-6 sm:mb-8 opacity-90 px-2">
              Faça parte do nosso grupo no WhatsApp e receba informações exclusivas sobre o empreendimento
            </p>
            <a 
              href="https://wa.me/5512999999999?text=Olá! Quero fazer parte do grupo exclusivo de investidores da Casagrande Empreendimentos. Tenho interesse no terreno para incorporação em São José dos Campos."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-yellow-600 hover:bg-gray-100 px-4 sm:px-6 lg:px-8 py-3 sm:py-4 rounded-lg font-bold text-sm sm:text-base lg:text-lg transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2 sm:gap-3"
            >
              <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
              <span className="hidden sm:inline">Entrar no Grupo de Investidores</span>
              <span className="sm:hidden">Entrar no Grupo</span>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-200 text-gray-800 py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            <div>
              <div className="flex items-center gap-4 mb-4 justify-center md:justify-start">
                <img 
                  src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/af14d36dc2eddb0ee47b75e3084e02db.png" 
                  alt="Luciana Casa Grande Arquitetura" 
                  className="h-24 sm:h-32 w-auto"
                />
              </div>
              <p className="text-gray-600 mb-4 text-sm sm:text-base text-center md:text-left px-2 md:px-0">
                Especialistas em oportunidades de investimento imobiliário com foco em terrenos 
                para incorporação em São José dos Campos, SP. Rentabilidade de 30% ao ano e segurança jurídica.
              </p>
            </div>
            <div className="text-center md:text-right">
              <a 
                href="https://wa.me/5512999999999?text=Olá! Tenho interesse nos investimentos da Casagrande Empreendimentos. Gostaria de mais informações."
                target="_blank"
                rel="noopener noreferrer"
                className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 sm:px-6 py-3 rounded-lg font-bold transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2 sm:gap-3 text-sm sm:text-base"
              >
                <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
                Falar no WhatsApp
              </a>
            </div>
          </div>
          
          {/* Legal Disclaimer */}
          <div className="bg-gray-100 rounded-lg p-4 sm:p-6 mt-6 sm:mt-8 mb-6 sm:mb-8 mx-2 sm:mx-0">
            <div className="text-center">
              <h4 className="font-bold text-gray-800 mb-3 text-sm sm:text-base">Informações Legais</h4>
              <div className="text-xs sm:text-sm text-gray-600 space-y-2 max-w-4xl mx-auto">
                <p>
                  <strong>Fotos Ilustrativas:</strong> Todas as imagens apresentadas neste material são meramente ilustrativas e têm caráter publicitário. 
                  As características finais do empreendimento podem sofrer alterações conforme aprovações dos órgãos competentes e memorial descritivo.
                </p>
                <p>
                  <strong>Regulamentação:</strong> Este investimento imobiliário não está vinculado às normas da CVM (Comissão de Valores Mobiliários), 
                  mas sim às normas do COFECI (Conselho Federal de Corretores de Imóveis) e CRECI (Conselho Regional de Corretores de Imóveis), 
                  que regulamentam as atividades do mercado imobiliário brasileiro.
                </p>
                <p>
                  <strong>Importante:</strong> Rentabilidade passada não é garantia de rentabilidade futura. 
                  todo investimento possui riscos. Recomendamos a leitura completa do material e consulta a profissionais especializados antes de investir.
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-400 mt-6 sm:mt-8 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-600 text-xs sm:text-sm text-center md:text-left">
              © 2024 Casagrande Empreendimentos. Todos os direitos reservados.
            </p>
          </div>

        </div>
      </footer>
    </div>
  );
};

export default Home;
